import { motion } from "framer-motion";

// Line-by-line masked reveal. `lines` is an array of strings/JSX (one per visual line).
export default function SplitText({
  lines = [],
  as: Tag = "h1",
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.11,
  duration = 0.95,
  animateOnLoad = true,
  once = true,
}) {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };
  const lineVar = {
    hidden: { y: "118%" },
    show: { y: "0%", transition: { duration, ease: [0.22, 1, 0.36, 1] } },
  };
  const motionProps = animateOnLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once, margin: "-12%" } };

  return (
    <Tag className={className}>
      <motion.span variants={container} {...motionProps} style={{ display: "block" }}>
        {lines.map((line, i) => (
          <span key={i} style={{ display: "block", overflow: "hidden", paddingBottom: "0.06em" }}>
            <motion.span
              variants={lineVar}
              className={lineClassName}
              style={{ display: "block", willChange: "transform" }}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </motion.span>
    </Tag>
  );
}
